<ion-row class="item-holder ion-align-items-center" *ngIf="loaded && !isMobile">
  <ion-col size="2">
    <div class="profile-div">
      <app-profile-image-item class="agentAvatar" [kioskCheck]="true" [profile]="marketserviceitem"
        [isImageService]="false">
      </app-profile-image-item>
    </div>
  </ion-col>
  <ion-col size="7">
    <div class="agentDiv">
      <div class="title" data-cy="publicProfileItem-username">
        {{marketserviceitem.name}}
      </div>
      <div class="description smallLightText" data-cy="publicProfileItem-company">
        {{marketserviceitem.description}}
      </div>
      <div class="social-buttons" *ngIf="showSocialLinks">
        <ng-container *ngFor="let item of socialLinks">
          <img *ngIf="item.enabled" [src]="item?.icon | safe:'url'" class="link" (click)="openSocialLink(item.URL)">
        </ng-container>
      </div>
    </div>
  </ion-col>
  <ion-col size="3" class="btnDiv">
    <ion-button color="primary" (click)="navigate(marketserviceitem)">
      {{marketserviceitem.buttonText}}
    </ion-button>
    <label *ngIf="marketserviceitem?.promotionText" class="codeLabel">{{marketserviceitem.promotionText}}</label>
  </ion-col>
</ion-row>

<ion-row class="item-holder ion-align-items-center mobile" *ngIf="loaded && isMobile">
  <ion-col size="12">
    <div class="profile-div">
      <app-profile-image-item class="agentAvatar" [kioskCheck]="true" [profile]="marketserviceitem"
        [isImageService]="false">
      </app-profile-image-item>
    </div>
  </ion-col>
  <ion-col size="12">
    <div class="agentDiv">
      <div class="title" data-cy="publicProfileItem-username">
        {{marketserviceitem?.name}}
      </div>
      <div class="description smallLightText" data-cy="publicProfileItem-company">
        {{marketserviceitem?.description}}
      </div>
      <div class="social-buttons" *ngIf="showSocialLinks">
        <ng-container *ngFor="let item of socialLinks">
          <img *ngIf="item.enabled" [src]="item?.icon | safe:'url'" class="link" (click)="openSocialLink(item.URL)">
        </ng-container>
      </div>
    </div>
  </ion-col>
  <ion-col size="12" class="btnDiv">
    <ion-button color="primary" (click)="navigate(marketserviceitem)">
      {{marketserviceitem?.buttonText}}
    </ion-button>
    <label *ngIf="marketserviceitem?.promotionText" class="codeLabel">{{marketserviceitem?.promotionText}}</label>
  </ion-col>
</ion-row>

<div class="skeletonContainer" *ngIf="!loaded">
  <ion-skeleton-text class="rounded" animated style="height:70px; width:70px;"></ion-skeleton-text>
  <div class="skeletonSub">
    <ion-skeleton-text animated style="height:12px; width:60%;"></ion-skeleton-text>
    <ion-skeleton-text animated style="height:12px; width:50%;"></ion-skeleton-text>
    <ion-skeleton-text animated style="height:12px; width:40%;"></ion-skeleton-text>
  </div>
</div>